export default __webpack_public_path__ + "static/media/gameSwitch.815dbafe.svg";